import { Component } from 'react'
import PropTypes from 'prop-types'

import UserClassBar from './UserClassBar'
import UserClassStory from './UserClassStory'

class UserClass extends Component {
  render() {
    const {
      isExpanded,
      classData,
      handleClassAction,
      classes,
      fetchPastEvents,
      cancelEventParticipation,
      renewUrl,
    } = this.props
    return (
      <div className={`ctp-userclass ${isExpanded ? 'is-expanded' : ''}`}>
        <UserClassBar
          classData={{
            icon: 'building',
            name: classData.name,
            total: classData.quantity,
          }}
          onClick={handleClassAction}
          renewUrl={renewUrl}
        />
        {classes !== 0 && classes && (
          <UserClassStory
            archive={classes.archive}
            planned={classes.planned}
            fetchPastEvents={fetchPastEvents}
            cancelEventParticipation={cancelEventParticipation}
          />
        )}
      </div>
    )
  }
}

UserClass.propTypes = {
  classData: PropTypes.object.isRequired,
  handleClassAction: PropTypes.func,
  isExpanded: PropTypes.bool,
  classes: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  fetchPastEvents: PropTypes.func,
  cancelEventParticipation: PropTypes.func,
  renewUrl: PropTypes.string,
}

export default UserClass
